module.exports = __webpack_public_path__ + "media/stylesheets/images/kv-001 1 2-b95e4df46d3a0d48baf8544a6b296317.jpg";